import {
    SET_LOADING,
    SET_LOCALE,
    SET_CONFIG,
    SET_GLOBAL_CONFIG,
    SET_MODULE,
    SET_MODULE_NAME,
    SET_APPLICATION_CODE,
    SET_CUSTOM_SETTINGS_MODULE,
    SET_PANEL,
    NAVIGATION_SET_ROUTE,
    BREADCRUMB_SET,
    TOC_SET_SELECTED,
    SET_CONFIG_MAP,
    SET_LOADING_MAP,
    SET_ACTION_MAP,
    SET_VIEW_PROJECTION_MAP,
    SET_BROADCASTING_ENABLED,
    SET_BROADCASTING_STATE,
    SET_ACTION,
    RESET_STATE
} from './mutation-types';
import { isString } from '@config/utils';

export default {
    setLoading ({ commit }, flag){
        commit(SET_LOADING, flag);
    },
    setLocale ({ commit }, locale){
        commit(SET_LOCALE, locale);
    },
    async setConfig ({ commit }, config){
        await commit(SET_CONFIG, config);
    },
    setGlobalConfig ({ commit }, module){
        commit(SET_GLOBAL_CONFIG, module);
    },
    setCustomSettings ({ commit, getters }, {module, themeConfig, config}){
        commit(SET_CUSTOM_SETTINGS_MODULE, { module, themeConfig, config, getters});
    },
    setApplicationCode ({ commit }, code){
        commit(SET_APPLICATION_CODE, code);
    },
    setModuleName ({ commit }, name){
        commit(SET_MODULE_NAME, name);
    },
    async setModule ({ commit, getters, dispatch }, module){
        commit(SET_MODULE, { module, getters});
        await dispatch('setGlobalConfig', module, { root: true });
    },
    setPanel ({ commit, getters }, {id, module, ...params}){
        commit(SET_PANEL, {getters, id, module, ...params});
    },
    resetState ({ commit }, {module, state = {}}) {
        commit(RESET_STATE, {module, newState: state})
    },

    // MAP
    setLoadingMap ({ commit }, {module, flag}){
        commit(SET_LOADING_MAP, {module, flag});
    },
    setConfigMap ({ commit }, {module, config}){
        commit(SET_CONFIG_MAP, {module, config});
    },
    setActionMap ({ commit }, {module, action}) {
        commit(SET_ACTION_MAP, {module, action});
    },
    setViewProjectionMap ({ commit }, {module, projection}) {
        commit(SET_VIEW_PROJECTION_MAP, {module, projection});
    },

    // NAVIGATION
    setNavigationRoute ({ commit }, route){
        commit(NAVIGATION_SET_ROUTE, route);
    },
    // BREADCRUMB
    breadcrumbChanged ({ commit, getters }, params){
        params = isString(params) ? {label: params} : params;
        commit(BREADCRUMB_SET, {getters, ...params});
    },
    // TOC
    tocSetSelected ({ commit, getters }, {idModule, ...params}){
        commit(TOC_SET_SELECTED, {getters, idModule, ...params});
    },
    // CATALOG
    catalogAction({ commit }, {type, ...params}) {
        commit(type, params);
    },
    // LAYER DOWNLOAD
    layerDownloadAction({ commit }, {type, ...params}) {
        commit(type, params);
    },
    // IDENTIFY DOWNLOAD
    identifyAction({ commit, getters }, {type, ...params}) {
        commit(type, {getters, ...params});
    },
    // FEATURE VIEWER
    featureViewerAction({ commit }, {type, ...params}) {
        commit(type, params);
    },
    // FEEDBACK OPTIONS
    feedbackOptionsAction({ commit }, {type, ...params}) {
        commit(type, params);
    },

    // BROADCASTING
    setBroadcastingEnabled({ commit }, {enabled, ...params}) {
        commit(SET_BROADCASTING_ENABLED, {enabled, ...params});
    },
    setBroadcastingState({ commit }, {state, ...params}) {
        commit(SET_BROADCASTING_STATE, {state, ...params});
    },

    setAction ({ commit }, {module, action}) {
        commit(SET_ACTION, {module, action});
    },
};
